const feeds = {}

const userId = () => String(localStorage.getItem("userId") || "")

export const loadHeaderFeed = (key, loader) => {
  const currentUser = userId()
  const entry = feeds[key]
  if (entry && entry.userId === currentUser) {
    if (entry.promise) return entry.promise
    return Promise.resolve(entry.data)
  }

  const promise = Promise.resolve()
    .then(loader)
    .then(data => {
      feeds[key] = { userId: currentUser, data }
      return data
    })
    .catch(error => {
      if (feeds[key] && feeds[key].promise) delete feeds[key]
      throw error
    })

  feeds[key] = { userId: currentUser, promise }
  return promise
}

export const setHeaderFeed = (key, data) => {
  feeds[key] = { userId: userId(), data }
}
